import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';
import { environment } from '@env/environment';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'app-footer',
	styleUrls: ['./footer.component.scss'],
	template: `
		<p class="m-0 text-white footer-right">
			<span class="created-by" [innerHTML]="'APP.COPYRIGHT' | translate">
			</span>
			<a href="https://www.eng.it" target="_blank" title="Visita il sito">
				<!-- per NgOptimizedImage mantenere aspect ratio width = 2.68 height-->
				<img
					ngSrc="assets/images/ENG24-LOGO-FULL-LIGHT.svg"
					alt="eng"
					height="32"
					width="85.76"
				/>
			</a>
		</p>
	`,
	standalone: true,
	imports: [NgOptimizedImage, TranslateModule]
})
export class FooterComponent {
	public readonly appVersion = environment.appVersion || 'unversioned';
}
